export function getDateDetails() {
  const date = new Date();

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();

  return { day, month, year, hour, minute };
}

export const dynamicDateErrorMessage = (errorPaths: string[]) => {
  let newDateErrorMessage;
  const missingParts = [];
  // Check which parts of the date are missing and add them to the array
  if (errorPaths.includes('selectedDay')) {
    missingParts.push('day');
  }
  if (errorPaths.includes('selectedMonth')) {
    missingParts.push('month');
  }
  if (errorPaths.includes('selectedYear')) {
    missingParts.push('year');
  }

  // Generate the error message based on the missing parts
  if (missingParts.length > 0) {
    newDateErrorMessage =
      missingParts.length === 3
        ? `The date must include a day, month, and year`
        : `The date must include a ${missingParts.join(' and  ')}`;
    return newDateErrorMessage;
  }
};

export const dynamicTimeErrorMessage = (errorPaths: string[]) => {
  let newTimeErrorMessage;
  const missingTimeParts = [];

  // Check which parts of the time are missing and add them to the array
  if (errorPaths.includes('selectedHour')) {
    missingTimeParts.push('hours');
  }
  if (errorPaths.includes('selectedMinute')) {
    missingTimeParts.push('minutes');
  }

  // Generate the error message based on the missing time parts
  if (missingTimeParts.length > 0) {
    newTimeErrorMessage = `The time must include ${missingTimeParts.join(' and ')}`;
    return newTimeErrorMessage;
  }
};

export const dynamicDateRangeErrorMessage = (
  errorPaths: string[],
  errors: {
    path: string;
    message: string;
  }[],
): string => {
  if (
    ['dayRange', 'monthRange', 'yearRange'].some((path) =>
      errorPaths.includes(path),
    )
  ) {
    return (
      errors.find((error) => error.path)?.message || 'Invalid date or time'
    );
  }
  return '';
};

export const dynamicTimeRangeErrorMessage = (
  errorPaths: string[],
  errors: {
    path: string;
    message: string;
  }[],
): string => {
  if (errorPaths.includes('hourRange')) {
    return errors.find((error) => error.path)?.message || 'Invalid hour';
  } else if (errorPaths.includes('minuteRange')) {
    return errors.find((error) => error.path)?.message || 'Invalid minute';
  }

  return '';
};
